module.exports = __webpack_public_path__ + "4146bc8703cd19a2391f77ea406184db.jpg";